export enum ScreenName {
  ADSchedule = 'ADSchedule',
  AD = 'adschedule-add-edit-popup',
  ADGrid = 'adschedule-grid',
  AGDC = 'AGDC',
  DailyDosing = 'DailyDosing',
  DataOverride = 'DataOverride',
  DosingRates = 'DosingRates',
  Expense = 'Expense',
  AdExpense = 'adexpense-add-edit-popup',
  OraExpense = 'oraexpense-add-edit-popup',
  SpsExpense = 'spsexpense-add-edit-popup',
  GeneratorInfo = 'GeneratorInfo',
  CustomerInfo = 'CustomerInfo',
  StreamPopup = 'stream-add-edit-popup',
  Recurring = 'recurring',
  SF = 'samplefrequency',
  Haulers = 'haulers',
  IP = 'invoiceprocess',
  LoadProjection = 'LoadProjection',
  ORF = 'ORF',
  ORA = 'oraschedule-add-edit-popup',
  ORAGrid = 'oraschedule-grid',
  PU = 'PU',
  Regions = 'Regions',
  Markets = 'markets',
  Sites = 'sites',
  SitePopup = 'sites-add-edit-popup',
  SLC = 'sitelockcodes',
  SPS = 'SPS',
  SPSGrid = 'spsschedule-grid',
  Strategic = 'spsschedule-add-edit-popup',
  ToteTransaction = 'ToteTransaction',
  TrashCompactor = 'TrashCompactor',
  ORAOutbound = 'ORAOutbound',
  TruckType = 'TruckType',
  SiteDataCapture = 'SiteDataCapture',
  Sitedowntime = 'sitedowntime',
  LabDataCapture = 'LabDataCapture',
  VGS = 'VGSgasinput'
}

export class ActionStatus {
  ShowGridDelete = false;
  ShowGridDuplicate = false;
  ShowGridDispatch = false;
  ShowGridEdit = false;
  ShowGridAdditionalInfo = false;
  ShowGridDispatchInfo = false;
  ShowGridActions = false;
  ShowADGridEditButton = false;
  DisableADGridDeleteButton = false;
  ShowADAttachButton = false;
  ShowADAddButton = false;
  ShowADDispatchButton = false;
  ShowORFDispatchButton = false;
  ShowSPSDispatchButton = false;
  ShowADGridSampleStatus = false;
  ShowADAdditionalStreamsAddButton = false;
  ShowADAdditionalStreamsGridActions = false;
  ShowORFAddButton = false;
  ShowORFUpdateStatusButton = false;
  DisableORFGridDeleteButton = false;
  ShowORFAttachButton = false;
  ShowORFGridEditButton = false;
  ShowORFAdditionalStreamsAddButton = false;
  ShowORFAdditionalStreamsGridActions = false;
  ShowSPSAddButton = false;
  ShowSPSUpdateStatusButton = false;
  ShowSPSGridEditButton = false;
  DisableSPSGridDeleteButton = false;
  ShowSPSAttachButton = false;
  ShowSPSAdditionalStreamsAddButton = false;
  ShowSPSAdditionalStreamsGridActions = false;
  ShowDailyDosingAddButton = false;
  ShowDailyDosingGridEditButton = false;
  ShowDailyDosingGridDeleteButton = false;
  ShowDosingRatesAddButton = false;
  ShowDosingRatesDupButton = false;
  ShowDosingRatesPopUpButton = false;
  ShowDataOverrideUpdateButton = false;
  ShowDataOverrideGridEditButton = false;
  ShowGeneratorAddButton = false;
  ShowGeneratorEditButton = false;
  ShowStreamAddButton = false;
  ShowExistingStreamAddButton = false;
  ShowStreamGridEditButton = false;
  ShowStreamGridActions = false;
  ShowStreamGridDeleteButton = false;
  ShowPickupLocationSaveButton = false;
  ShowStreamRecurGridActions = false;
  ShowStreamRecurrAddButton = false;
  ShowStreamRecurrEditButton = false;
  ShowStreamRecurrDeleteButton = false;
  ShowStreamSamplingFreqGridActions = false;
  ShowStreamSamplingFreqAddButton = false;
  ShowStreamSamplingFreqEditButton = false;
  ShowStreamSamplingFreqDeleteButton = false;
  ShowStreamAdditionalSalesRepGridActions = false;
  ShowStreamAdditionalSalesRepGridAddButton = false;
  ShowStreamProjectedVolumeAndHauler = false;
  ShowPriceMatrixGridActionsButton = false;
  ShowPriceMatrixGridEditButton = false;
  ShowPriceMatrixGridDuplicateButton = false;
  ShowPriceMatrixAddButton = false;
  ShowChemistryGridActionsButton = false;
  ShowChemistryGridEditButton = false;
  ShowLabData = false;
  ShowChemistryAddButton = false;
  ShowMetalsGridActionsButton = false;
  ShowMetalsGridEditButton = false;
  ShowMetalsAddButton = false;
  ShowCustomerGridDeleteButton = false
  ShowChemistryGridDeleteButton = false;
  ShowMetalsGridDeleteButton = false;
  ShowPriceMatrixGridDeleteButton = false;
  ShowHaulersGridActionsButton = false;
  ShowHaulersGridEditButton = false;
  ShowHaulersGridDeleteButton = false;
  ShowHaulersAddButton = false;
  ShowVGSGasInputGridActionsButton = false;
  ShowVGSGasInputAddButton = false;
  ShowSitesGridEditButton = false;
  ShowSitesGridDeleteButton = false;
  ShowSitesAddButton = false;
  ShowTruckTypeAddButton = false;
  ShowTrashCompactorAddButton = false;
  ShowORAOutboundAddButton = false;
  ShowTrashCompactorGridActionsButton = false;
  ShowORAOutboundGridEditButton = false;
  ShowORAOutboundGridDeleteButton = false
  ShowUpdateStatusButton = false;
  ShowPopupViewOnly = false;
  ShowPopupStatusOnly = false;
  ShowPopupSaveButton = false;
  ShowRevenueAddButton = false;
  ShowRevenueGridActions = false;
  ShowRevenueGridEditButton = false;
  ShowRevenueGridDeleteButton = false;
  ShowAAGDispatchAddButton = false;
  ShowAGDCAddButton = false;
  ShowAGDCEditButton = false;
  ShowAGDCDeleteButton = false;
  ShowAGDCSaveButton = false;
  ShowPUSaveButton = false;
  ShowPUEditButton = false;
  ShowPUDeleteButton = false;
  ShowSLCSaveButton = false;
  ShowIPReprocessButton = false;
  ShowIPMonthEndReportButton = false;
  ShowRegionsGridEditButton = false;
  ShowRegionsGridDeleteButton = false;
  ShowRegionsAddButton = false;
  ShowMarketAddButton = false;
  ShowMarketGridEditButton = false;
  ShowMarketGridDeleteButton = false;
  AllowIsReviewdToggle = false;
  ShowPopupForInternalNotes = false;
  ShowToteTab = false;
  ShowTotePriceMatrixGridActionsButton = false;
  ShowTotePriceMatrixGridEditButton = false;
  ShowTotePriceMatrixGridDuplicateButton = false;

  ShowTotePriceMatrixGridDeleteButton = false;
  ShowTotePriceMatrixAddButton = false;
  ShowTotePriceMatrixGridActions = false;
  ShowRentalTypeGridActions = false;
  ShowRentalTypeGridEditButton = false;
  ShowRentalTypeGridDeleteButton = false;
  ShowRentalTypeGridAddButton = false;
  ShowToteTransactionAddButton = false;
  ShowToteTransactionGridActionsButton = false;
  ShowToteTransactionGridEditButton = false;
  ShowToteTransactionGridDeleteButton = false;
  ShowToteTransactionGridDuplicateButton = false;
  ShowSDCDeleteButton = false;
  ShowSDCEditButton = false;
  ShowSDCAddButton = false;
  ShowSDCSaveButton = false;
  ShowLabDeleteButton = false;
  ShowLabEditButton = false;
  ShowLabAddButton = false;
  ShowLabSaveButton = false;
  ShowPriceMatrixAdditionalSalesRepGridAddButton = false;
  ShowPriceMatrixAdditionalSalesRepGridActions = false;
  ShowPriceMatrixAdditionalSalesRepGridEditButton = false;
  ShowPriceMatrixAdditionalSalesRepGridDeleteButton = false;
  ShowDocumentDeleteButton = false;
}

export class LoadScheduleControlFlags {
  market: boolean= true;
  pickupDate: boolean= true;
  actualDate: boolean= true;
  customer:  boolean= true;
  stream: boolean= true;
  noOfBins: boolean = true;
  site:  boolean= true;
  hauler: boolean= true;
  tank:  boolean= true;
  uom: boolean= true;
  projectedQuantity: boolean= true;
  actualQuantity: boolean= true;
  actualTons: boolean= true;
  actualVolume:  boolean= true;
  disposalMethod: boolean= true;
  feeCategory: boolean= true;
  flatFee: boolean= true;
  rebateQuantity: boolean = true;
  haulingExpense: boolean= true;
  status: boolean= true;
  cancelReason:  boolean= true;
  cancelReasonNotes: boolean= true;
  customerReferenceNo:  boolean= true;
  driverName: boolean= true;
  trailerNumber: boolean= true;
  truckNumber: boolean= true;
  notesForHauler: boolean= true;
  notesForCustomer: boolean= true;
  codNotes:  boolean= true;
  seal:  boolean= true;
  bol: boolean= true;
  holdLoadOnComplete: boolean= true;
  invoiceThisLoad: boolean= true;
  divertedLoad:  boolean= true;
  loadSlipNumber: boolean= true;
  internalNotes: boolean= true;
  internalSiteHaulCostReason: boolean= true;
  truckType: boolean= true;
  schedulingNotes: boolean= true;
  notesForDisposalSite: boolean= true;
  scWorkOrder: boolean = true;
  saveButton: boolean= false;
  addStreamButton: boolean = false;
  addtStreamGridActions: boolean = false;
  editStreamButton: boolean = false;
  deleteStreamButton: boolean = false; 
  addButton: boolean = false;
  dispatch_Button: boolean = false;
  updateStatus: boolean = false;
  duplicate: boolean = false;
  edit: boolean = false;
  delete: boolean = false;
  addionalInfo: boolean = false;
  dispatchInfo: boolean = false;
  sampleStatusChange: boolean = false;
  showDocumentDeleteButton: boolean = false;
  showToteTab: boolean = false;
  showLabTab: boolean = false;
  addCustomer: boolean = false;
  editCustomer: boolean = false;
  deleteCustomer : boolean = false;
  addStream : boolean = false;
  addExistingStream: boolean = false;
  editStream: boolean = false;
  deleteStream: boolean = false;
  addPriceMatrix : boolean = false;
  duplicatePriceMatrix: boolean = false;
  editPriceMatrix: boolean = false;
  deletePriceMatrix: boolean = false;
  addSalesRep: boolean = false;
  editSalesRep: boolean = false;
  deleteSalesRep: boolean = false;
  addTotePriceMatrix: boolean = false;
  editTotePriceMatrix: boolean = false;
  duplicateTotePriceMatrix: boolean = false;
  deleteTotePriceMatrix: boolean = false;
  addChemistry: boolean = false;
  editChemistry: boolean = false;
  deleteChemistry: boolean = false;
  addMetal: boolean = false;
  editMetal: boolean = false;
  deleteMetal: boolean = false;
  reprocess:boolean = false;
  generateReport: boolean = false;


  //streampopup
  //stream: boolean = false;
  minimalCharges: boolean = false;
  codRequired: boolean = false;
  codEmail: boolean = false;
  //status: boolean = false;
  isTote: boolean = false;
  commissionEligible: boolean = false;
  rebateEligible: boolean = false;
  streamFood: boolean = false;
  streamMatrix: boolean = false;
  customerID: boolean = false;
  salesRep: boolean = false;
  salesRepId: boolean = false;
  siteNumber: boolean = false;
  haulerId: boolean = false;
  strengthID: boolean = false;
  projectedVolume: boolean = false;
  disposalMethodId: boolean = false;
  opportunityID: boolean = false;
  marketID: boolean = false;
  pickupLocationName: boolean = false;
  addressLine1: boolean = false;
  addressLine2: boolean = false;
  city: boolean = false;
  state: boolean = false;
  zipCode: boolean = false;
  selfHaulEmail: boolean = false;
  selfHaulPhone: boolean = false;
  municipality: boolean = false;
  sameAsCustomerAddress: boolean = false;
  stateId: boolean = false;
  bdr: boolean = false;
  isExpense: boolean = false;
  isOutBound: boolean = false;
  allowIsReviewdToggle: boolean = false;
  isCustomerReferenceRequired: boolean = false;
  sitename : boolean = true;
  trigger: boolean = true;
}

export const VISIBILITY_CONTROLS = new Set([
  'btnSave','addButton','addionalInfo','delete','dispatch_Button','dispatchInfo',
  'duplicate','edit','sampleStatusChange','addStreamButton','editStreamButton','deleteStreamButton',
  'showDocumentDeleteButton', 'showattachdocuments','updateStatus',,'addCustomer','editCustomer','deleteCustomer','addStream',
  'editStream','addExistingStream','deleteStream','addPriceMatrix','editPriceMatrix','duplicatePriceMatrix',
  'deletePriceMatrix','addTotePriceMatrix','editTotePriceMatrix','duplicateTotePriceMatrix','deleteTotePriceMatrix',
  'addChemistry','editChemistry','deleteChemistry','addMetal','editMetal','deleteMetal','showToteTab','showLabTab',
  'addSalesRep','editSalesRep','deleteSalesRep','allowIsReviewdToggle','reprocess','generateReport'
]);

export interface ScreenControlPermission {
  id:            number;
  screenName:    string;
  control:       string;   // matches FormGroup control names exactly
  isWriteAccess: boolean;   // 1 = editable, 0 = disabled
}